import { render, staticRenderFns } from "./DragDropFile.vue?vue&type=template&id=bd048f9e"
import script from "./DragDropFile.vue?vue&type=script&lang=js"
export * from "./DragDropFile.vue?vue&type=script&lang=js"
import style0 from "./DragDropFile.vue?vue&type=style&index=0&id=bd048f9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports